import { render, staticRenderFns } from "./ItemDeleteDialog.vue?vue&type=template&id=72d08ef4&scoped=true&"
import script from "./ItemDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./ItemDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d08ef4",
  null
  
)

export default component.exports